import { useEffect } from 'react'

import { ITask } from '@/types/task.interface'

interface IUseLiveTranscriptionPolling {
	sourceType: ITask['source_type'] | undefined
	status: ITask['status'] | undefined
	refetchTranscriptions: () => Promise<void>
}

export const useLiveTranscriptionPolling = ({
	sourceType,
	status,
	refetchTranscriptions
}: IUseLiveTranscriptionPolling) => {
	useEffect(() => {
		if (sourceType !== 'listener' || status !== 'in_progress') return

		const interval = setInterval(() => {
			refetchTranscriptions()
		}, 5000)

		return () => clearInterval(interval)
	}, [sourceType, status, refetchTranscriptions])
}
